import React, { useContext } from "react";
import {
  UncontrolledDropdown,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
} from "reactstrap";
import axios from "axios";
import * as Icon from "react-feather";
import { UserContext } from "./../../../context/context";
import { URL_IMG } from "../../../config";
import imgDefault from "./../../../assets/img/logo/avatarDefault.png?";
import { PURGE } from "redux-persist";
import { useDispatch } from "react-redux";

const UserDropdown = (props) => {
  const { activateAuth } = useContext(UserContext);
  const dispatch = useDispatch();
  return (
    <DropdownMenu>
      <DropdownItem
        onClick={() => {
          activateAuth(null);
          sessionStorage.clear();
          dispatch({
            type: PURGE,
            key: "root", // Whatever you chose for the "key" value when initialising redux-persist in the **persistCombineReducers** method - e.g. "root"
            result: () => null, // Func expected on the submitted action.
          });
        }}
      >
        <Icon.Power size={14} color={"#626262"} className="mr-50" />
        <span style={{ color: "#626262" }} className="align-middle">
          Cerrar sesión
        </span>
      </DropdownItem>
    </DropdownMenu>
  );
};

class NavbarUser extends React.PureComponent {
  state = {
    navbarSearch: false,
    suggestions: [],
  };
  user = JSON.parse(sessionStorage.getItem("user"));

  componentDidMount() {
    this._isMounted = true;

    axios
      .get("/api/main-search/data")
      .then(({ data }) => {
        if (this._isMounted) {
          this.setState({ suggestions: data.searchResult });
        }
      })
      .catch((error) => {
        if (this._isMounted) {
          console.error(error);
        }
      });
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  handleNavbarSearch = () => {
    this.setState({
      navbarSearch: !this.state.navbarSearch,
    });
  };

  render() {
    return (
      <ul className="nav navbar-nav navbar-nav-user float-right">
        <UncontrolledDropdown tag="li" className="dropdown-user nav-item">
          <DropdownToggle tag="a" className="nav-link dropdown-user-link">
            <div className="user-nav d-sm-flex d-none">
              <span className="user-name text-bold-600">
                {`${this.user?.name}`}
              </span>
              <span className="user-status">
                {this.user?.profile === 1
                  ? "Master"
                  : this.user?.profile === 2
                  ? "Operador"
                  : this.user?.profile === 3
                  ? "Supervisor"
                  : this.user?.profile === 4
                  ? "Gerente"
                  : this.user?.profile === 5
                  ? "Cliente"
                  : this.user?.profile === 6
                  ? "Monitoreo"
                  : this.user?.profile === 7
                  ? "Director de Operaciones"
                  : this.user?.profile === 10
                  ? "Porteria"
                  : this.user?.profile === 11
                  ? "Coordinador de Región"
                  : this.user?.profile === 12
                  ? "Gerente Supply Logistics"
                  : this.user?.profile === 13
                  ? "Administrativo"
                  : this.user?.profile === 14
                  ? "Administración"
                  : this.user?.profile === 15
                  ? "Contabilidad Supply Logistics"
                  : this.user?.profile === 17
                  ? "Lider de Operacion"
                  : this.user?.profile === 18
                  ? "Torre de Control"
                  : this.user?.profile === 19
                  ? "Gerente de Planta"
                  : this.user?.profile === 20
                  ? "Gerente Edinsa"
                  : this.user?.profile === 21
                  ? "Porteria*"
                  : this.user?.profile === 22
                  ? "Analistas Administrativo"
                  : this.user?.profile === 23
                  ? "Coordinador de Planta"
                  : this.user?.profile === 24
                  ? "Nómina"
                  : this.user?.profile === 25
                  ? "Control Interno"
                  : "Supply"}
              </span>
            </div>
            <span data-tour="user">
              <img
                src={
                  this.user?.photo ? `${URL_IMG}/${this.user?.photo}` : imgDefault
                }
                className="round"
                height="40"
                width="40"
                alt="avatar"
              />
            </span>
          </DropdownToggle>
          <UserDropdown {...this.props} />
        </UncontrolledDropdown>
      </ul>
    );
  }
}
export default NavbarUser;
